import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, HostBinding, Input, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
animations: [
  trigger('indicatorRotate', [
    state('collapsed', style({transform: 'rotate(0deg)'})),
    state('expanded', style({transform: 'rotate(180deg)'})),
    transition('expanded <=> collapsed',
      animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
    ),
  ])
]
@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss']
})
export class MenuListItemComponent implements OnInit {
  expanded: boolean =false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: any;
  @Input() depth: number;   
  constructor(
    public activatedRoute:ActivatedRoute,
    public location:Location,
    public router: Router
  ) {
      if (this.depth === undefined) {
        this.depth = 0;
      }    
   }

  ngOnInit(): void {
 
  }
  
  onItemSelected(item: any) {
    console.log("ITEEEEEMMM", item)
    if (!item.children || !item.children.length) {
        if(item.route == null){
//          console.log("item.route is null")
          this.router.navigate([this.router.url.substring(1,38)],{queryParams:{component_id:item.component_id ,componentName:item.componentName,component_serialNumber:item.component_serialNumber}});        
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';          
          this.router.navigate([this.router.url.substring(1,38)],{queryParams:{component_id:item.component_id,componentName:item.componentName,component_serialNumber:item.component_serialNumber}});        
        }else{
          this.router.navigate([item.route],{queryParams:{component_id:item.component_id,componentName:item.componentName,component_serialNumber:item.component_serialNumber}});        
        }
        
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }  

}
